import Button from "@/atoms/Button";
import PropTypes from "prop-types";

/**
 * Purchase button that can optionally show the total above it.
 *
 * @param {Object} props
 * @param {Boolean} props.disabled
 * @param {Function} props.onSubmit
 * @param {String} props.orderTotal
 * @param {String} props.className
 * @param {String} props.dataTestId
 * @param {String} props.paymentButtonLabel
 * @param {Boolean} props.loading
 */
const CheckoutPurchaseButtonWithTotal = ({
  disabled,
  onSubmit,
  orderTotal,
  className,
  dataTestId,
  paymentButtonLabel,
  loading,
}) => {
  return (
    <div className={className}>
      {orderTotal && (
        <div className="flex justify-between pt-10">
          <div className="font-medium text-text-textGray-darker pr-3">
            Today&apos;s Total
          </div>
          <div className="font-medium text-textGray-darker">{orderTotal}</div>
        </div>
      )}
      <Button
        dataTestId={dataTestId}
        type={"submit"}
        onClick={onSubmit}
        className="my-5 w-full"
        disabled={disabled}
        label={paymentButtonLabel || "Complete Order"}
        color={"teal"}
        loading={loading}
      />
    </div>
  );
};

CheckoutPurchaseButtonWithTotal.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  orderTotal: PropTypes.string,
  dataTestId: PropTypes.string,
  paymentButtonLabel: PropTypes.string,
  loading: PropTypes.bool,
};

export default CheckoutPurchaseButtonWithTotal;
